import { render, staticRenderFns } from "./ChartsPage.vue?vue&type=template&id=f1171838&"
import script from "./ChartsPage.vue?vue&type=script&lang=js&"
export * from "./ChartsPage.vue?vue&type=script&lang=js&"
import style0 from "./ChartsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports